import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Navigation } from 'lucide-react';
export function Location() {
  return <section id="ubicacion" className="py-24 bg-cream bg-grain relative" data-id="element-116">
      <div className="max-w-7xl mx-auto px-6" data-id="element-117">
        <div className="text-center mb-16" data-id="element-118">
          <span className="text-orange font-bold tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-119">
            Visítanos
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-coral" data-id="element-120">
            DÓNDE ESTAMOS
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch" data-id="element-121">
          {/* Info Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-4 bg-burgundy text-cream p-10 rounded-3xl shadow-xl flex flex-col justify-center relative overflow-hidden" data-id="element-122">
            {/* Decorative background pattern */}
            <div className="absolute inset-0 opacity-5 bg-papel-picado pointer-events-none" data-id="element-123" />

            <div className="relative z-10" data-id="element-124">
              <div className="mb-10" data-id="element-125">
                <div className="flex items-start gap-4 mb-6" data-id="element-126">
                  <div className="bg-orange/20 p-3 rounded-full text-orange-light mt-1" data-id="element-127">
                    <MapPin size={24} data-id="element-128" />
                  </div>
                  <div data-id="element-129">
                    <h4 className="font-display text-xl font-bold mb-2" data-id="element-130">
                      Dirección
                    </h4>
                    <p className="text-cream/80 text-lg" data-id="element-131">Littleton, NC 27850</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-132">
                  <div className="bg-orange/20 p-3 rounded-full text-orange-light mt-1" data-id="element-133">
                    <Phone size={24} data-id="element-134" />
                  </div>
                  <div data-id="element-135">
                    <h4 className="font-display text-xl font-bold mb-2" data-id="element-136">
                      Teléfono
                    </h4>
                    <p className="text-cream/80 text-lg" data-id="element-137">(252) 213-1970</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-4 mt-auto" data-id="element-138">
                <a href="tel:+12522131970" className="flex items-center justify-center gap-2 bg-orange hover:bg-orange-light text-white py-4 rounded-xl font-bold tracking-wide transition-colors w-full" data-id="element-139">
                  <Phone size={20} data-id="element-140" />
                  LLAMAR
                </a>
                <a href="https://www.google.com/maps/dir/?api=1&destination=Littleton+NC+27850" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-transparent border-2 border-cream/30 hover:border-cream text-cream py-4 rounded-xl font-bold tracking-wide transition-colors w-full" data-id="element-141">
                  <Navigation size={20} data-id="element-142" />
                  CÓMO LLEGAR
                </a>
              </div>
            </div>
          </motion.div>

          {/* Map Embed */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 rounded-3xl overflow-hidden shadow-lg h-[400px] lg:h-auto border-4 border-cream-alt" data-id="element-143">
            <iframe src="https://maps.google.com/maps?q=Littleton+NC+27850&t=&z=13&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Location for The Happy Taco" className="w-full h-full grayscale-[20%] contrast-[1.1]" data-id="element-144"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}